"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnNavigation = exports.Section = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const report_row_1 = __importStar(require("../../../components/report-row"));
const bureau_score_overview_1 = __importDefault(require("./bureau-score-overview"));
exports.Section = styled_components_1.default.div.withConfig({ displayName: "reports-Section", componentId: "reports-1r388w3" }) `
  & > ${report_row_1.ReportRowWrapper}:first-child {
    border-top: 0;
  }
`;
/** TODO: Add REPORTS_BASE_URL to ent_web and pipsqueak */
const { REPORTS_BASE_URL } = (_a = process.env) !== null && _a !== void 0 ? _a : '/partner';
const ColumnNavigation = ({ bureauSlug, scoreType, children, hasMatch, reportDate, reportException, reportItems = [], score, }) => (react_1.default.createElement(base_react_components_1.StandardCard, { "data-testid": `${bureauSlug}-report:page:column-nav` },
    react_1.default.createElement(bureau_score_overview_1.default, { bureauSlug: bureauSlug, scoreType: scoreType, hasMatch: hasMatch, reportDate: reportDate, score: score }),
    !reportException && hasMatch ? (react_1.default.createElement("div", { "data-testid": `${bureauSlug}-report:page:column-nav-items` }, reportItems.map((rows, sectionKey) => (react_1.default.createElement(exports.Section, { key: sectionKey },
        rows.map(({ amount, label, route, value }, i) => (react_1.default.createElement(report_row_1.default, { amount: amount, "data-testid": `${bureauSlug}-report:page:${label}`, href: `${REPORTS_BASE_URL}/reports/${bureauSlug}${route}`, key: i, label: label, value: value }))),
        react_1.default.createElement(base_react_components_1.Divider, null)))))) : (react_1.default.createElement("div", { "data-testid": `${bureauSlug}-report:page:report-error` }, reportException)),
    children));
exports.ColumnNavigation = ColumnNavigation;
exports.default = exports.ColumnNavigation;
//# sourceMappingURL=column-navigation.js.map